/**
 * Minimum properties associated with the `aria-controls` property.
 *
 * The aria controls type is used to identify components controleld by another
 * like tabs and the content they refer to.
 */
export type StateWithAriaControls = {
  root: {
    "aria-controls"?: string;
  };
};

/**
 * Process the `state` as a mutable draft state and set the `aria-controls` property according
 * to `valueOrDefaultValue`.
 */
export function useAriaControls<T extends StateWithAriaControls>(
  state: T,
  value?: string
) {
  if (value !== undefined) {
    state.root["aria-controls"] = value;
  }
}
